import type { IconSvgObject } from './types';

const ChartGanttIcon: IconSvgObject = [
  ["path", { d: "M3 3V19C3 20.1046 3.89543 21 5 21H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11 6H19M7 11H14M13 16H19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default ChartGanttIcon;
